import React, {useEffect, useState} from 'react';
import './ResetRequestPage.css';
import Logo from "../../components/logo/Logo";
import Notification from "../../components/notification/Notification";
import {useNavigate, useSearchParams} from "react-router-dom";
import {getAuthUrl} from "../../utils";

function ResetRequestPage() {
    const [searchParams] = useSearchParams();
    const [isAgent, setIsAgent] = useState(false);
    const [redirectUrl, setRedirectUrl] = useState("");

    useEffect(() => {
        if (searchParams.get("auth-type") === "agent") {
            setIsAgent(true)
        }
        setRedirectUrl(searchParams.get("redirect_url"));
    }, [setIsAgent, searchParams]);

    const [credentials, setCredentials] = useState({
        email: "",
    });

    const [showNotification, setShowNotification] = useState(false);
    const [notificationType, setNotificationType] = useState("");
    const [notificationMessage, setNotificationMessage] = useState("");
    const [isLoading, setIsLoading] = useState(false);
    const navigate = useNavigate();

    const handleInputChange = (event) => {
        const { name, value } = event.target;
        setCredentials(prevState => ({
            ...prevState,
            [name]: value
        }));
    };

    const clearNotification = () => {
        setTimeout(() => {
            setShowNotification(false);
        }, 350);
    }

    const submit = (e) => {
        e.preventDefault();
        setIsLoading(true);
        fetch(getAuthUrl(isAgent) + "/request-reset", {
            method: "POST",
            headers: { 'Content-Type': 'application/json' },
            body: JSON.stringify(credentials)
        }).then((res) => {
            if (res.status === 200) {
                setNotificationType("success");
                setNotificationMessage("Reset password email successfully send.");
                setShowNotification(true);
                setIsLoading(false);
                navigate("/request-sent" + (isAgent ? "?auth-type=agent" : ""))
            } else {
                setNotificationType("error");
                setNotificationMessage("Une erreur inattendue s'est produite. Veuillez réessayer plus tard. Si le problème persiste, n'hésitez pas à contacter notre support client.");
                setShowNotification(true);
                setIsLoading(false);
            }
        })
        .catch((error) => {
            console.error(error);
            setNotificationType("error");
            setNotificationMessage("Une erreur inattendue s'est produite. Veuillez réessayer plus tard. Si le problème persiste, n'hésitez pas à contacter notre support client.");
            setShowNotification(true);
            setIsLoading(false);
        });
    };

    return <div className="flex min-h-full flex-1 flex-col justify-center py-12 sm:px-6 lg:px-8">
        <div className="cp-bg-gray mt-10 sm:rounded-lg sm:mx-auto sm:w-full sm:max-w-[480px]">
            <div className="bg-white py-4 px-16 m-8 rounded-lg">
                <Logo/>
            </div>

            <h2 className="mt-6 text-center text-2xl font-bold leading-9 tracking-tight text-gray-100">
                Mot de passe oublié
            </h2>

            {showNotification ? <Notification done={clearNotification} type={notificationType}
                                              message={notificationMessage}></Notification> : <></>}

            <div className="px-6 py-12 shadow sm:px-12">
                <form className="space-y-6" action={null} method="POST" onSubmit={submit}>
                    <div>
                        <label htmlFor="email" className="block text-sm font-medium leading-6 text-gray-100">
                            Email <span className="text-orange-600 font-bold text-lg">*</span>
                        </label>
                        <div className="mt-2">
                        <input
                                id="email"
                                name="email"
                                type="email"
                                autoComplete="email"
                                required
                                onChange={handleInputChange}
                                className="block w-full rounded-md border-0 py-1.5 pl-2 text-gray-800 shadow-sm ring-1 ring-inset ring-gray-300 placeholder:text-gray-400 focus:ring-2 focus:ring-inset focus:ring-indigo-600 sm:text-sm sm:leading-6"
                            />
                        </div>
                    </div>

                    <div className="pt-8">
                        <button
                            type="submit"
                            className="mt-0 flex w-full justify-center rounded-md cp-bg-orange px-3 py-1.5 text-sm font-semibold leading-6 text-white shadow-sm hover:cp-bg-orange-light focus-visible:outline focus-visible:outline-2 focus-visible:outline-offset-2 focus-visible:outline-indigo-600">
                            {
                                isLoading
                                    ?   <div className="inline-block h-6 w-6 animate-spin rounded-full border-2 border-solid border-current border-e-transparent text-surface motion-reduce:animate-[spin_1.5s_linear_infinite] dark:text-white mr-2" role="status">
                                        <span className="!absolute !-m-px !h-px !w-px !overflow-hidden !whitespace-nowrap !border-0 !p-0 ![clip:rect(0,0,0,0)]"></span>
                                    </div>
                                    : <>Envoyer</>
                            }
                        </button>
                        <a href={"/login?redirect_url=" + redirectUrl + (isAgent ? "&auth-type=agent" : "")} className="font-semibold text-gray-100 hover:cp-text-orange text-xs">
                            Retour à la page de connexion
                        </a>
                    </div>
                </form>
            </div>
        </div>
    </div>
}

export default ResetRequestPage;
